module.exports = __webpack_public_path__ + "static/media/ADANIPORTS_F1.c8c79b3e.txt";